import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "auth-device-drawer" }
const _hoisted_2 = { class: "auth-device-drawer__toolbar" }
const _hoisted_3 = { class: "auth-device-drawer__summary" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = ["checked", "disabled", "onChange"]
const _hoisted_6 = { class: "auth-device-drawer__main" }
const _hoisted_7 = { class: "auth-device-drawer__title" }
const _hoisted_8 = { class: "auth-device-drawer__meta" }
const _hoisted_9 = { class: "auth-device-drawer__meta" }
const _hoisted_10 = {
  key: 0,
  class: "auth-device-drawer__empty"
}
const _hoisted_11 = { class: "auth-device-drawer__footer" }

import { computed, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { useApi } from '@/hooks/useApi';


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthorizeDeviceDrawer',
  emits: ['saved'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const visible = ref(false);
const loading = ref(false);
const adminId = ref<number>();
const adminName = ref('');
const keyword = ref('');
const devices = ref<any[]>([]);
const selectedDeviceIds = ref(new Set<number>());
const authorizeAllDevices = ref(false);

const filteredDevices = computed(() => {
  const key = keyword.value.trim().toLowerCase();
  if (!key) {
    return devices.value;
  }
  return devices.value.filter((device) => [
    device.remark,
    device.idHex,
    device.serialNumber,
  ].some((value) => String(value || '').toLowerCase()
    .includes(key)));
});

const toggleDevice = (deviceId: number) => {
  if (authorizeAllDevices.value) {
    return;
  }
  const next = new Set(selectedDeviceIds.value);
  if (next.has(deviceId)) {
    next.delete(deviceId);
  } else {
    next.add(deviceId);
  }
  selectedDeviceIds.value = next;
};

const toggleAuthorizeAll = () => {
  authorizeAllDevices.value = !authorizeAllDevices.value;
  if (authorizeAllDevices.value) {
    selectedDeviceIds.value = new Set<number>();
    keyword.value = '';
  }
};

const loadDevices = async() => {
  const res = await useApi().deviceApi.listDeviceDevice({ conditions: {} });
  devices.value = res.data.data || [];
};

const loadAuthorizedDeviceInfo = async(id: number) => {
  const res = await useApi().adminDeviceAuthApi.getAuthorizedDeviceInfo(id);
  authorizeAllDevices.value = Boolean(res.data.data?.authorizeAllDevices);
  selectedDeviceIds.value = new Set((res.data.data?.deviceIds || []) as number[]);
};

const show = async(row: any) => {
  adminId.value = row.id;
  adminName.value = row.name || row.phone || '';
  keyword.value = '';
  authorizeAllDevices.value = false;
  visible.value = true;
  loading.value = true;
  try {
    await Promise.all([
      loadDevices(),
      loadAuthorizedDeviceInfo(row.id),
    ]);
  } finally {
    loading.value = false;
  }
};

const handleSave = async() => {
  if (!adminId.value) {
    ElMessage.error('请选择账号');
    return;
  }
  loading.value = true;
  try {
    await useApi().adminDeviceAuthApi.saveAuthorizedDevices({
      adminId: adminId.value,
      authorizeAllDevices: authorizeAllDevices.value,
      deviceIds: authorizeAllDevices.value ? [] : Array.from(selectedDeviceIds.value),
    });
    ElMessage.success(authorizeAllDevices.value ? '已授权全部设备' : '授权设备保存成功');
    visible.value = false;
    emit('saved');
  } finally {
    loading.value = false;
  }
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_HpsfirInput = _resolveComponent("HpsfirInput")!
  const _component_HpsfirButton = _resolveComponent("HpsfirButton")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!

  return (_openBlock(), _createBlock(_component_HpsfirProDrawer, {
    open: visible.value,
    "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: `授权设备${adminName.value ? ` - ${adminName.value}` : ''}`,
    width: "860px",
    "max-width": "calc(100vw - 32px)",
    "mobile-height": "75vh",
    "mobile-max-height": "75vh",
    "content-class": "business-table-drawer",
    "body-class": "business-table-drawer__body"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_HpsfirButton, {
          variant: "outline",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_HpsfirButton, {
          loading: loading.value,
          onClick: handleSave
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("保存授权", -1)
          ]))]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_HpsfirInput, {
            modelValue: keyword.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
            placeholder: "搜索设备备注 / 设备序列号 / 原始序列号",
            class: "auth-device-drawer__search",
            disabled: authorizeAllDevices.value
          }, null, 8, ["modelValue", "disabled"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(authorizeAllDevices.value ? '已授权全部设备（含后续新增）' : `已选 ${selectedDeviceIds.value.size} / 共 ${filteredDevices.value.length} 台`), 1)
        ]),
        _createElementVNode("label", {
          class: _normalizeClass(["auth-device-drawer__all", { 'auth-device-drawer__all--checked': authorizeAllDevices.value }])
        }, [
          _createElementVNode("input", {
            class: "auth-device-drawer__checkbox",
            type: "checkbox",
            checked: authorizeAllDevices.value,
            onChange: toggleAuthorizeAll
          }, null, 40, _hoisted_4),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "auth-device-drawer__all-main" }, [
            _createElementVNode("span", { class: "auth-device-drawer__title" }, "授权全部设备"),
            _createElementVNode("span", { class: "auth-device-drawer__meta" }, "不保存具体设备明细，当前和后续新增设备都可见，效果与管理员查看设备范围一致。")
          ], -1))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["auth-device-drawer__list", { 'auth-device-drawer__list--disabled': authorizeAllDevices.value }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDevices.value, (device) => {
            return (_openBlock(), _createElementBlock("label", {
              key: device.id,
              class: _normalizeClass(["auth-device-drawer__item", { 'auth-device-drawer__item--checked': selectedDeviceIds.value.has(device.id) }])
            }, [
              _createElementVNode("input", {
                class: "auth-device-drawer__checkbox",
                type: "checkbox",
                checked: selectedDeviceIds.value.has(device.id),
                disabled: authorizeAllDevices.value,
                onChange: ($event: any) => (toggleDevice(device.id))
              }, null, 40, _hoisted_5),
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(device.remark || '未备注设备'), 1),
                _createElementVNode("span", _hoisted_8, "设备序列号：" + _toDisplayString(device.idHex || '-'), 1),
                _createElementVNode("span", _hoisted_9, "原始序列号：" + _toDisplayString(device.serialNumber || '-'), 1)
              ])
            ], 2))
          }), 128)),
          (!filteredDevices.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "暂无设备"))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["open", "title"]))
}
}

})